var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-group',_vm._l((_vm.configs),function(config,index){return _c('v-image',{key:index,attrs:{"config":Object.assign({}, _vm.configImage, config)}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }